export const UI_FRAMEWORK_SM_WIDTH = 576;
export const UI_FRAMEWORK_MD_WIDTH = 991;
